import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
const urlParams = new URLSearchParams(window.location.search);
const pVal = urlParams.get('clientId');
const defaultClientId = (pVal ? parseInt(pVal, 10) : 0);
const isSelVal = urlParams.get('isSelectable');
const isSel = (isSelVal && isSelVal.toLowerCase() === 'true' ? true : false);
console.log('isSelectable: ', isSel);
const selAudienceVal = urlParams.get('selectedAudienceID');
const selAudienceID = selAudienceVal ? +selAudienceVal : 0;
console.log('selectedAudienceID: ', selAudienceID);
// const eInsightUserEmail = urlParams.get('userEmail');
// console.log('eInsightUserEmail: ', eInsightUserEmail);
export const state = {
    counter: 0,
    clientId: defaultClientId,
    companyId: 0,
    isSelectable: isSel,
    selectedAudienceID: selAudienceID,
    environmentName: 'eInsight QA Application',
    // eInsightUserEmail: eInsightUserEmail,
    dirtyPageValidation: {
        dirty: false,
        message: ''
    }
};
const namespaced = true;
export const counter = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
//# sourceMappingURL=index.js.map